'use client';

import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { ChakraProvider, ModalProvider, useScreenStore, ScreenContext } from '@shared/ui';
import { cookie, COOKIE_KEY_MAP } from '@shared/services';
import { useMember, MemberProvider } from 'app/context/useMember';
import { useEffectOnce } from 'libs/useEffectOnce';
import { preinit } from 'app/preinit';
import { BackToPanel } from './BackToPanel';

const hasMerchantBrandId = !!cookie.get(COOKIE_KEY_MAP.brandId);

const hasMerchantUID = !!cookie.get(COOKIE_KEY_MAP.uid);

export function ClientBody(props: { children: React.ReactNode }) {
    const { children } = props;

    const { status: screenStatus } = useScreenStore();

    const memberApi = useMember();

    const pathname = usePathname();

    useEffectOnce(() => {
        preinit('member');
    });

    useEffect(() => {
        window.scroll(0, 0);
    }, [pathname]);

    return (
        <body className="shop-custom-page-main" suppressHydrationWarning>
            <ChakraProvider
                theme={{
                    styles: {
                        global: {
                            body: {
                                bg: 'neutral.000',
                                color: 'neutral.120',
                                overflowX: 'hidden',
                                '--toast-z-index': '10000',
                            },
                        },
                    },
                }}
            >
                <MemberProvider value={memberApi}>
                    <ScreenContext.Provider value={{ status: screenStatus }}>
                        {hasMerchantBrandId && hasMerchantUID && <BackToPanel />}
                        {children}
                        <ModalProvider />
                    </ScreenContext.Provider>
                </MemberProvider>
            </ChakraProvider>
        </body>
    );
}
